module.exports = __webpack_public_path__ + "img/10_70.924a6ceb.png";